import { render, staticRenderFns } from "./BroadcastStatus.vue?vue&type=template&id=10740f73&"
import script from "./BroadcastStatus.vue?vue&type=script&lang=js&"
export * from "./BroadcastStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports